'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _StoryAction2 = require('./StoryAction');

var _StoryAction3 = _interopRequireDefault(_StoryAction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_StoryAction) {
  _inherits(_class, _StoryAction);

  function _class(_ref) {
    var game = _ref.game,
        data = _ref.data;

    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, game, data));
  }

  _createClass(_class, [{
    key: 'onEnable',
    value: function onEnable() {
      _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'onEnable', this).call(this);

      this.game.camera.fade('#FFFFFF');
    }
  }, {
    key: 'onFadeComplete',
    value: function onFadeComplete() {}
    /*
      tweenTint(obj, startColor, endColor, time) {
        var colorBlend = {step: 0}; 
        var colorTween = game.add.tween(colorBlend).to({step: 100}, time);
    
        colorTween.onUpdateCallback(function() {
          obj.tint = Phaser.Color.interpolateColor(startColor, endColor, 100, colorBlend.step);
        })
    
        obj.tint = startColor;
        
        colorTween.start();
      }
    */

  }]);

  return _class;
}(_StoryAction3.default);

exports.default = _class;


//////////////////
// WEBPACK FOOTER
// ./src/story/GoodEndingAction.js
// module id = 353
// module chunks = 0